import {getOffset} from '../../utils/helpers';
require('smoothscroll-polyfill').polyfill();

export default class scrollDownButton {
    constructor() {
        this.container = document.querySelector('.topSection');
        if (this.container) {
            this.el = this.container.querySelector('.scrollDownButton');
            this.bindEvents();
        }
    }

    bindEvents() {
        this.el.addEventListener('click', () => this.scrollDown());
    }

    scrollDown() {
        const container = this.container;
        const pos = getOffset(container) + container.clientHeight;
        window.scroll({ top: pos, left: 0, behavior: 'smooth' });
    }
}



// WEBPACK FOOTER //
// ./src/components/scrollDownButton/scrollDownButton.js